export default "__VITE_PUBLIC_ASSET__abb63600__"